// extracted by mini-css-extract-plugin
export default {"header":"TxajKX9sn3NTkNR_Jwzg"};